<template lang="pug">
#sidebar.sidebar.app-aside
    .sidebar-container
        nav
            // start: MAIN NAVIGATION MENU
            .navbar-title
                span  Навигация
            ul.main-navigation-menu
                menu-item(
                    title='Информация о магазине',
                    route-name='EditShop',
                    fa-cls='fa-info'
                )
                menu-item(
                    title='Виджет',
                    route-name='WidgetSettings',
                    fa-cls='fa-newspaper-o'
                )
                menu-item(
                    title='Расчёт стоимости и сроков',
                    route-name='Calculator',
                    fa-cls='fa-calculator'
                )
                menu-item(
                    title='Службы доставки',
                    route-name='DeliveryServices',
                    fa-cls='fa-truck'
                )
                menu-item(
                    title='Правила',
                    route-name='CostRules',
                    fa-cls='fa-tags'
                )
                menu-item(
                    title='Промокоды',
                    route-name='Promocodes',
                    fa-cls='fa-ticket'
                )
                menu-item(
                    title='Выгрузка заказов'
                    route-name='OrdersTransferList'
                    fa-cls='fa-exchange'
                )
            .wrapper
                a.button-o(
                    href="https://salesbeat.pro/integrations/tilda",
                    target="_blank",
                    v-if="cmsId === 'Tilda Publishing'"
                )
                    | Как установить в <b>Тильду</b>?
            // end: MAIN NAVIGATION MENU
</template>

<script>
import { mapState } from 'vuex';

const MenuItem = {
    template: `
        <li :class="isOpened(routeName)">
            <router-link class="sidebar-mobile-toggler"
                         :to="{name: routeName}"
                         data-toggle-class='app-slide-off'
                         data-toggle-target='#app'>
                <div class="item-content">
                    <div class="item-media"><i :class="['fa', faCls]"></i></div>
                    <div class="item-inner"><span class="title"> {{ title }} </span></div>
                </div>
            </router-link>
        </li>
    `,
    props: {
        title: String,
        routeName: String,
        faCls: String
    },
    computed: mapState([
        'openedMenuItem'
    ]),
    methods: {
        isOpened(name) {
            return { active: this.openedMenuItem === name };
        }
    }
};

export default {
    name: 'Sidebar',

    components: {
        'menu-item': MenuItem
    },

    computed: {
        ...mapState({
            experiments: (state) => state.users.experiments,
            cmsId: (state) => state.localStorage.selectedShop.cms_id
        })
    }
};
</script>

<style>
    .item-media {
        min-width: 46px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue